import React from "react";
import "./Sponsors.scss";

// Types
import { CurrentSegmentComponentProps } from "../SettingsTypes";

// Hooks
import { useTranslation } from "react-i18next";

// Components
import { faMoneyCheckDollar } from "@fortawesome/pro-regular-svg-icons";
import { IonNote } from "@ionic/react";
import ImageSection from "../../../../components/Admin/Settings/ImageSection";
import SubTitle from "../../../../components/Admin/Settings/SubTitle";
import { InputFactory } from "../../../../components/Factories/Input";

export default function SponsorsSegment(props: CurrentSegmentComponentProps) {
  const { t } = useTranslation();
  const { formData, updateFormData, errors } = props;

  return (
    <div className="page--admin--settings--sponsors">
      <SubTitle text={t("sponsors")} icon={faMoneyCheckDollar} />

      <div className={`input__container input__container--type-text ${errors?.["sponsor.name"] && "has-error"}`}>
        <InputFactory
          type="text"
          value={formData?.sponsor?.name}
          name="sponsor.name"
          placeholder={t("sponsorsName")}
          onIonChange={updateFormData}
          className={"input__input input-factory__input input-factory__input--type-text"}
        />
        {errors?.["sponsor.name"] && <IonNote color="danger">{errors?.["sponsor.name"]}</IonNote>}
      </div>

      <div className={`input__container input__container--type-text ${errors?.["sponsor.url_website"] && "has-error"}`}>
        <InputFactory
          type="text"
          value={formData?.sponsor?.url_website}
          name="sponsor.url_website"
          placeholder={t("sponsorsWebsite")}
          onIonChange={updateFormData}
          className={"input__input input-factory__input input-factory__input--type-text"}
        />
        {errors?.["sponsor.url_website"] && <IonNote color="danger">{errors?.["sponsor.url_website"]}</IonNote>}
      </div>

      <ImageSection
        title={`${t("headerLogo")}`}
        value={formData?.sponsor?.img_path_header_logo}
        changeHandler={updateFormData}
        errors={errors}
        text="Please ensure that there is enough contrast between your logo and the header background colour. See 'Colours' section in the brand tab."
        minDimensions={{ width: 200, height: 80 }}
        name="sponsor.img_path_header_logo"
        noInputLabel
      />

      <ImageSection
        title={`${t("loadingScreenImage")}`}
        value={formData?.sponsor?.img_path_loading_screen}
        errors={errors}
        text="Please upload a potrait image. Please avoid positioning text and relevant content close the edges as it may be cropped on certain screen sizes."
        changeHandler={updateFormData}
        minDimensions={{ width: 720, height: 1580 }}
        name="sponsor.img_path_loading_screen"
        noInputLabel
      />

      <div className="page--admin--settings--sponsors__seconds-loading">
        <span>{t("showTheLoadingScreenFor")} </span>

        <InputFactory
          type="number"
          step={1}
          min={0}
          value={formData?.sponsor?.seconds_loading}
          name="sponsor.seconds_loading"
          onIonChange={updateFormData}
          className={"input__input input-factory__input input-factory__input--type-text"}
        />

        <span> {t("seconds")}</span>
      </div>
    </div>
  );
}
